import React from "react";

export function NumberField({value, placeholder, onChange, dateOriginalTitle}) {

    return <section>
        <label className="input">
            <i className=""></i>
            <input type="text" id="phone_no" data-toggle="tooltip" data-placement="bottom" placeholder={placeholder}
                   data-original-title={dateOriginalTitle}
                   value={value}
                   onChange={(event) => onChange && onChange(event.target.value)}
                   required="required"
            />
            <b className="tooltip tooltip-bottom-right">{dateOriginalTitle} </b>

        </label>
    </section>

}